export default "__VITE_ASSET__gPUXMqoa__"